import React, { useState } from "react"
import { useSearchParams } from "react-router-dom"
import { Layout, Typography, Card, theme } from "antd"
import { useTranslation } from "react-i18next"
import { useDevice } from "hooks/useDevice"
import { ChatHistory } from "../ChatHistory"
import { ConversationList } from "pagesV2/pro/Messages/ConversationList"
import { GroupMessages } from "ui/Icon/DSIcon/GroupMessages"
import { GroupSearch } from "ui/Icon/DSIcon/GroupSearch"
import styles from "../EmptyState.module.css"
import { useSelector } from "react-redux"
import { collectionSelector } from "store/selectors"

const { Content } = Layout
const { Title, Text } = Typography
const { useToken } = theme

export const renderEmptyStateCard = (IconComponent, title, description, color) => (
  <div className={styles.emptyMessageCard}>
    <Card className={styles.noMessageCard}>
      <div className={styles.messageIcon}>
        <IconComponent fill={color} width={"83px"} height={"50px"} />
      </div>
      <Content className={styles.noMessageContent}>
        <Title level={3}>{title}</Title>
        <Text type="secondary">{description}</Text>
      </Content>
    </Card>
  </div>
)

export const ChatConversation = () => {
  const [searchParams] = useSearchParams()
  const { t } = useTranslation()
  const { token } = useToken()
  const { isMobile, isTablet } = useDevice()
  const [subscription, setSubscription] = useState(null) // State to store the subscription
  const [inputValue, setInputValue] = useState("")
  const selectedConversationId = parseInt(searchParams.get("conversation_id"), 10) || null
  const isSmallDevice = isMobile || isTablet
  const shouldRenderConversationList = !isSmallDevice || !selectedConversationId
  const conversations = useSelector(collectionSelector("conversations"))
  const activeConversation = conversations.length === 0 && !selectedConversationId
  const showNoResult = inputValue && activeConversation
  const showEmptyMessages = !selectedConversationId && conversations.length > 0
  const showStartMessagePrompt = !inputValue && activeConversation
  const guideClientId = conversations?.filter((conversation) => conversation.id === selectedConversationId)?.[0]?.guide_client_id
const isClient = conversations?.find((conversation) => conversation.id === selectedConversationId)?.client?.is_client
  const renderEmptyState = () => {
    if (showNoResult) {
      return renderEmptyStateCard(GroupSearch, t("messenger.no_result"), t("messenger.no_search_result"), token.colorPrimary)
    } else if (showEmptyMessages) {
      return renderEmptyStateCard(GroupMessages, t("messenger.empty_messages_title"), t("messenger.start_conversation"), token.colorPrimary)
    } else if (showStartMessagePrompt) {
      return renderEmptyStateCard(GroupMessages, t("messenger.empty_messages_title"), t("messenger.empty_messages"), token.colorPrimary)
    }
    return null
  }

  const shouldRenderChatPanel = !isSmallDevice || (isSmallDevice && Boolean(selectedConversationId))

  return (
    <div className="flex-column flex-grow-1">
      <Layout>
        {shouldRenderConversationList && (
          <ConversationList
            conversations={conversations}
            selectedConversationId={selectedConversationId}
            isSmallDevice={isSmallDevice}
            setInputValue={setInputValue}
            inputValue={inputValue}
            setSubscription={setSubscription}
          />
        )}

        {shouldRenderChatPanel && (
          <Layout style={{ flex: 1, position: "relative" }} className={styles.messageWrapper}>
            {Boolean(selectedConversationId) && (
              <ChatHistory selectedConversationId={selectedConversationId} subscription={subscription} setSubscription={setSubscription} guideClientId={guideClientId} isClient={isClient} />
            )}
            {!isSmallDevice && renderEmptyState()}
          </Layout>
        )}
      </Layout>
    </div>
  )
}